import { defineComponent as _defineComponent } from 'vue'
import { IListableProductJson } from 'JS/types/Product';


export default /*#__PURE__*/_defineComponent({
  __name: 'TireHeader',
  props: {
    product: null
  },
  emits: ["product-link-click"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'product-link-click', elementEvent: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit }
}

})